import React, { useState } from "react";
import { db } from "../firebase";
import { collection, addDoc } from "firebase/firestore";
import { motion } from "framer-motion";
import "../styles/ContactPage.css";

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    altPhone: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // ✅ VALIDATION
  const validate = () => {
    if (!formData.name.trim()) return "Name is required";

    if (!/^[0-9]{10}$/.test(formData.phone))
      return "Enter valid 10-digit phone number";

    if (formData.altPhone && !/^[0-9]{10}$/.test(formData.altPhone))
      return "Invalid alternative phone";

    if (!/^\S+@\S+\.\S+$/.test(formData.email))
      return "Invalid email address";

    if (!formData.message.trim() || formData.message.length < 5)
      return "Message too short";

    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const error = validate();
    if (error) {
      setSuccess(error);
      return;
    }

    setLoading(true);

    try {
      await addDoc(collection(db, "inquiries"), {
        ...formData,
        createdAt: new Date(),
      });

      setSuccess("✅ Inquiry submitted successfully!");
      setFormData({
        name: "",
        phone: "",
        altPhone: "",
        email: "",
        message: "",
      });

      setTimeout(() => setSuccess(null), 3000); // auto hide
    } catch (err) {
      setSuccess("❌ Failed to submit. Try again.");
    }

    setLoading(false);
  };

  return (
    <motion.div
      className="contact-container"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
    >
      <h1 className="contact-header">Contact Us</h1>
      <p className="contact-subtext">
        We’d love to hear from you 💚
      </p>

      <form onSubmit={handleSubmit} className="contact-form">

        <div className="input-group">
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            className="contact-input"
          />

          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleChange}
            className="contact-input"
          />
        </div>

        <input
          type="tel"
          name="altPhone"
          placeholder="Alternative Phone"
          value={formData.altPhone}
          onChange={handleChange}
          className="contact-input"
        />

        <input
          type="email"
          name="email"
          placeholder="Email Address"
          value={formData.email}
          onChange={handleChange}
          className="contact-input"
        />

        <textarea
          name="message"
          placeholder="Write your message..."
          value={formData.message}
          onChange={handleChange}
          className="contact-textarea"
        />

        <button type="submit" className="contact-button" disabled={loading}>
          {loading ? <span className="loader"></span> : "Send Message"}
        </button>

        {success && <p className="success-message">{success}</p>}
      </form>
    </motion.div>
  );
};

export default ContactPage;